import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AdminHeader } from '../AdminLayout'
import { PurgePanel } from '../components/PurgePanel'
import { SettingsPanel } from '../components/SettingsPanel'
import { useAdminContext } from '../session'

/**
 * Les réglages, à leur propre adresse.
 *
 * Ils existaient déjà, mais tout en bas de l'écran « Événement », après le
 * nom, la date, l'adresse et les contacts — et aucune entrée de menu ne
 * portait le mot. On ne trouve pas un réglage en faisant défiler un
 * formulaire d'édition en espérant qu'il soit dessous : on le cherche là où
 * c'est écrit « Réglages ».
 *
 * Le panneau reste le même composant, inchangé : il lit le registre du
 * serveur et dessine ce qu'on lui envoie. Ce qui change ici, c'est qu'on peut
 * y arriver.
 */
export function AdminSettingsPage() {
  const { t } = useTranslation()
  const { eventId } = useAdminContext()

  useEffect(() => {
    document.title = t('admin.section.settings')
  }, [t])

  return (
    <>
      <AdminHeader
        title={t('admin.section.settings')}
        description={t('admin.settings.description')}
      />
      <SettingsPanel eventId={eventId} />
      <PurgePanel eventId={eventId} />
    </>
  )
}
